angular.module(NgAppName).component('crDropdown', {
	templateUrl: 'crDropdown.html',
	bindings: {
		filter: '<',
		type: '@',
		defaultText: '@',
		autoSubmit: '<',
		form: '<',
		formData: '<', // for toggleview widget
		errorMessages: '<',
		allowToUnselect: '<',
		showSelectedOptions: '<',
		showIcon: "<",
		onMapView: '<',
		onValueChangedDropdown: '&',
		setTitleFnc: '<' // can override the setTitleFnc so it can be more flexible
	},
	controller: ['$timeout', 'PubSub', '$element', function($timeout, PubSub, $element) {
		var ctrl = this;

		this.opened = false;
		this.isMultiSelect = this.type === 'single' ? false : true;
		this.isAutoSubmit = this.autoSubmit == 'no' ? false : true;
		this.showIcon = typeof(this.showIcon) === "undefined" ? true : this.showIcon;
		this.uuid = Core.uuid();

		this.toggleList = function() {
			this.opened = !this.opened;
		};

		this.toggleOption = function(option) {
			if (this.loadingResults) {
				return;
			}

			if (this.isMultiSelect) {
				option.active = !option.active;
			} else {
				if (this.allowToUnselect && option.active) {
					option.active = false;
					this.activeOption = null;
				} else {
					if (this.activeOption) {
						this.activeOption.active = false;
					}

					option.active = true;
					this.activeOption = option;
				}

				this.onDateRange = option.label === 'Search By Date Range' && option.active;

				// close the list (only single selection)
				if (!this.onDateRange) {
					this.toggleList();
				}
			}

			this.setTitle();

			if (this.isAutoSubmit) {
				this.onValueChangedDropdown({option: option});
			}
		};

		this.setTitle = function() {
			if (this.setTitleFnc) {
				var title = this.setTitleFnc();
				this.filterName = title;
				return;
			}
			if (this.filter && this.isMultiSelect) {
				if (this.showSelectedOptions) {
					var counter = 0;
					var selectedOptions = '';
					var withBeds = '';

					angular.forEach(this.filter.options, function(option) {
						if (!option.active) {
							return;
						}

						if (ctrl.filter.name === 'bedrooms') {
							var text = option.label.replace('Studios', 'Studio');
							text = text.split(' ')[0];
							selectedOptions += (counter > 0? ', ' : ' ') + text;

							if (option.label.indexOf('Bedrooms') > -1 || option.label.indexOf('Beds') > -1) {
								withBeds = 'Beds';
							} else if (option.label.indexOf('Bedroom') > -1 || option.label.indexOf('Bed') > -1) {
								withBeds = 'Bed';
							}
						} else {
							selectedOptions += (counter > 0? ', ' : ' ') + option.label;
						}

						counter++;
					});

					// if (counter === this.filter.options.length-1) {
					if (counter === this.filter.options.length) {
						this.filterName = 'All';
					} else {
						this.filterName = selectedOptions? selectedOptions + ' ' + withBeds : null;
					}
				} else {
					var optionsNumber = this.filter.options.length;
					var activeNumber = this.getActiveNumber();
					if (activeNumber == 0 || activeNumber == optionsNumber) {
						this.filterName = 'All ' + this.filter.name;
					} else {
						this.filterName = this.filter.name + ' (' + activeNumber + ' of ' + optionsNumber + ')';
					}
				}
			} else {
				if (this.activeOption) {
					this.filterName = this.activeOption.label;
				} else {
					this.filterName = null;
				}
			}
		};

		this.getActiveNumber = function() {
			var activeNumber = 0;
			angular.forEach(this.filter.options, function(opt) {
				if (opt.active) {
					activeNumber++;
				}
			});

			return activeNumber;
		};

		this.displayErrorMessage = function() {
			var res = false;

			if (this.form && this.form.$submitted) {
				if (this.isMultiSelect) {
					// if (this.getActiveNumber() === 0) {
					// 	res = true;
					// }
				} else if (!this.activeOption) {
					res = true;
				}
			}

			return res;
		};

		this.setDefault = function() {
			if (this.isMultiSelect) {
				return;
			}

			if (this.filter) {
				angular.forEach(this.filter.options, function(option) {
					if (option.active === true) {
						ctrl.activeOption = option;
					}

					ctrl.onDateRange = option.label === 'Search By Date Range' && option.active;
				});
			}
		};

		this.setDateRangeValue = function(data) {
			if (data.dateFrom) {
				ctrl.filter.dateFrom = data.dateFrom;
				if (ctrl.formData && ctrl.formData.filters) {
					ctrl.formData.filters.dateFrom = data.dateFrom;
				}
			} else if (data.dateTo) {
				ctrl.filter.dateTo = data.dateTo;
				if (ctrl.formData && ctrl.formData.filters) {
					ctrl.formData.filters.dateTo = data.dateTo;
				}
			}
		};

		this.applyDateRangeValue = function(data) {
			ctrl.setDateRangeValue(data);

			if (ctrl.isAutoSubmit) {
				ctrl.onValueChangedDropdown({option: ctrl.activeOption});
			}
		};

		this.reset = () => {
			this.activeOption = null;
			this.setDefault();
			this.setTitle();
		};

		if (this.filter && (this.filter.name === 'date listed' || this.filter.name === 'date closed')) {
			PubSub.subscribe('setDateRangeValue', this.setDateRangeValue);
			PubSub.subscribe('applyDateRangeValue', this.applyDateRangeValue);
		}

		PubSub.subscribe('resetDropdown', this.reset);

		// INIT
		this.setDefault();
		this.setTitle();
	}]
});
